import React from 'react';
import scaleSize from 'utils/scale-size';

export default () => {
  return (
    <svg
      width={scaleSize(85)}
      height={scaleSize(85)}
      viewBox="0 0 85 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.3337 0.416656H50.917V8.83332H59.3337V17.25H8.83366V25.6667H0.416992V46.7083H8.83366V25.6667H59.3337V34.0833H50.917V42.5H59.3337V34.0833H67.7503V25.6667H76.167V17.25H67.7503V8.83332H59.3337V0.416656ZM17.2503 76.1667H25.667V84.5833H34.0837V76.1667H25.667V67.75H76.167V59.3333H84.5837V38.2917H76.167V59.3333H25.667V50.9167H34.0837V42.5H25.667V50.9167H17.2503V59.3333H8.83366V67.75H17.2503V76.1667Z"
        fill="#9F9F9F"
      />
    </svg>
  );
};
